import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-add-segment',
  templateUrl: './add-segment.component.html',
  styleUrls: ['./add-segment.component.scss']
})
export class AddSegmentComponent implements OnInit {

  private _newSegment: string = '';

  constructor() {
  }

  ngOnInit() {
  }

  get newSegment(): string {
    return this._newSegment;
  }

  set newSegment(value: string) {
    this._newSegment = value;
  }

  newSegmentTextBoxChange(newValue) {
    this._newSegment = newValue;
  }

}
